module.exports = __webpack_public_path__ + "img/so.8d00822d.svg";